import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TriggerModeOption } from "../trigger-mode-radio-group/trigger-mode-radio-group.component";

@Component({
  selector: "app-flow-test-app-state-section",
  templateUrl: "./flow-test-app-state-section.component.html",
  styleUrls: [
    "../app-install/app-install-trigger-form.component.scss",
    "./shared-trigger-section.component.scss",
  ],
})
export class FlowTestAppStateSectionComponent {
  @Input() group!: FormGroup;
  @Input() modeOptions: TriggerModeOption[] = [];
  @Input() locationPermissionOptions: Array<{ value: number; label: string }> = [];
  @Input() title = "App State";
  @Input() requirementLabel = "Required";
  @Input() generateHint =
    "Sandbox app-state permissions, app version, and locale will be generated with plausible defaults.";
  @Input() specifyHint =
    "These values are saved to the sandbox app-device state and control permission/version/locale conditions.";

  get mode(): string {
    return this.group.get("mode")!.value;
  }
}
